import { formatYYMMDDandTime } from "./format";

export type SurveyDetailField = {
  key: "id" | "createdBy" | "lockedBy" | "locked";
  label: string;
  value: string;
};

type SurveyDetailInput = {
  id: number;
  created_by_name?: string | null;
  locked_by_name?: string | null;
  locked_time?: string | null;
};

/**
 * Shared survey metadata fields for ListView and SurveyDetailsNavigator.
 * Empty values always render as "-" so both surfaces stay in sync.
 */
export function buildSurveyDetailFields(
  survey: SurveyDetailInput
): SurveyDetailField[] {
  return [
    { key: "id", label: "ID", value: String(survey.id) },
    {
      key: "createdBy",
      label: "Created By",
      value: survey.created_by_name || "-",
    },
    {
      key: "lockedBy",
      label: "Locked By",
      value: survey.locked_by_name || "-",
    },
    {
      key: "locked",
      label: "Locked",
      value: survey.locked_time
        ? formatYYMMDDandTime(survey.locked_time)
        : "-",
    },
  ];
}
